// apps/web/src/ui/FeedbackEntry.tsx
// 问题反馈入口（@wc/feedback SDK，直连统一控制台 admin.nju.top）。
// 设计约束：
// - 不影响画布主功能：入口是右下角独立悬浮按钮（不参与画布事件/布局），
//   且抬高避开底部居中的绘图工具栏（小屏折行时也不重叠）；
// - 可发现性：常显按钮 + 未读红点（管理员回复后点亮）；
// - 深色应用主题：widget 走 --fb-* 变量的 dark 模式。
import { FeedbackWidget } from '@wc/feedback/react';
import '@wc/feedback/styles.css';
import '../feedback-entry.css';
import { useAuth } from '../state/auth';
import { displayName } from '../utils/name';

const DEV = import.meta.env.DEV;

// 公钥可公开（防滥用靠控制台 origin 白名单 + 限流）
const PUBLIC_KEY = DEV
  ? 'pk_blackborad_dev_12c67c9ef63d'
  : 'pk_blackborad_prod_3299fe8eb84c6c67';
const BASE_URL = DEV ? 'http://localhost:8091' : 'https://admin.nju.top';

export function FeedbackEntry() {
  // 登录用户随工单上报身份——否则控制台里全是"游客"，无法回访定位
  const user = useAuth((s) => s.user);
  return (
    <FeedbackWidget
      mode="direct"
      baseUrl={BASE_URL}
      publicKey={PUBLIC_KEY}
      userId={user?.id ?? null}
      userDisplay={user ? displayName(user) : null}
      variant="float"
      buttonLabel="反馈"
      theme={{ mode: 'dark', brand: '#f5b642', brandSoft: 'rgba(245,182,66,0.16)', radius: '12px', zIndex: 60 }}
      getDiagnostics={() => ({
        app: 'blackborad',
        page: location.pathname,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        board: location.pathname.startsWith('/b/') ? location.pathname.slice(3) : null,
      })}
      pollIntervalMs={120_000}
    />
  );
}
